import {FC} from "react";
import {BeneficiaryMainComponent} from "../../components";
import {PageEnum, SupplierCustomerTypeEnum} from "../../models";

export const SupplierPage: FC = () => {
    //#region html
    return (
        <BeneficiaryMainComponent formId={PageEnum.Suppliers} type={SupplierCustomerTypeEnum.Supplier}/>
    );
    //#endregion
};
